import { getApiClient } from './ApiClient'

// Read-only: health_data_type / health_data_source rows ship with the code that reads them, via a
// db/data patch, so the API exposes no write route.
export const healthDataTypeListPromise = () => {
  return getApiClient()
    .get('/health-data-types')
    .then(resp => resp.data)
}
